<script>
import jx from "./lib/jx";
import cx from "./lib/cx";
import btj from "./lib/btj";
import scxg from "./lib/scxg";
import common from "@/common/mixins/common.js";

export default {
  components: {
    jx,
    cx,
    btj,
    scxg,
  },
  data() {
    return {
      activeShow: 1,
      lang: "en",
      goodsTypes: [],//商品类型
      // goodTypeKey2name: {},
      goodsTypesALl: [],//全部商品类型,中英文
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          },
        }, {
          text: "最近一个月",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          },
        }, {
          text: "最近三个月",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          },
        }, {
          text: "最近半年",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit("pick", [start, end]);
          },
        }, {
          text: "最近一年",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit("pick", [start, end]);
          },
        }],
      },
    };
  },
  created() {
    this.initLang();
    this.getGoodsType();
  },
  //  监听lang参数变化
  watch: {
    lang: {
      handler(newVal, oldVal) {
        this.getGoodsType();
      },
      deep: true,
    },
  },
  methods: {
    initLang() {
      if (this.$i18n.locale) {
        this.lang = this.$i18n.locale;
      } else {
        this.lang = "en";
      }
    },
    // 获取商品类型
    getGoodsType() {
      this.$axios.get("/w1/goodsType/ForCart").then((res) => {
        this.goodsTypesALl = res.data.data;
        this.setGoodsTypeShow(this.lang);
      });
    },
    // 设置商品类型显示
    setGoodsTypeShow(lang) {
      if (lang == "en") {
        this.goodsTypes = this.goodsTypesALl.en;
      } else {
        this.goodsTypes = this.goodsTypesALl.cn;
      }
    },
    actShow(num) {
      this.activeShow = num;
    },

  },
};
</script>

<template>
  <div class="center">
    <h1 class="title">经营分析</h1>
    <ul class="nav">
      <li :class="activeShow===1?'h':''" @click="actShow(1)">
        <!--进销对比-->
        进销对比
      </li>
      <li :class="activeShow===2?'h':''" @click="actShow(2)">
        <!--畅销对比-->
        畅销对比
      </li>
      <li :class="activeShow===3?'h':''" @click="actShow(3)">
        <!--不推荐商品-->
        不推荐商品
      </li>
      <li :class="activeShow===4?'h':''" @click="actShow(4)">
        <!--首次选购商品-->
        首次选购商品
      </li>
    </ul>

    <div class="c_div">
      <jx v-if="activeShow===1" :goodsTypes="goodsTypes" :lang="lang" :pickerOptions="pickerOptions" />
      <cx v-if="activeShow===2" :goodsTypes="goodsTypes" :lang="lang" :pickerOptions="pickerOptions" />
      <btj v-if="activeShow===3" :goodsTypes="goodsTypes" :lang="lang" :pickerOptions="pickerOptions" />
      <scxg v-if="activeShow===4" :goodsTypes="goodsTypes" :lang="lang" :pickerOptions="pickerOptions" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.center {
  width: 1200px;
  border: 1px solid #bebebe;
  margin: 17px;
  min-height: 840px;
  background: #fff;
}

.title {
  font-weight: 700;
}

.nav {
  display: flex;
  margin-top: 10px;
}

.nav li {
  width: 150px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  margin-right: 10px;
  background: #fff;
  color: black;
  border-bottom: 2px solid #ccc;
  cursor: pointer;
}

.nav .h {
  border: 1px solid #0090a1;
  border-bottom: 3px solid #ff9900;
  color: #fff;
  cursor: pointer;
  background: #0090a1;
  font-weight: 700;
}

.c_div {
  width: 100%;
  min-height: 500px;
  margin: 10px 0;
  height: auto;
}
</style>